"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableHeadBtn_styles_1 = __importDefault(require("./TableHeadBtn.styles"));
var lodash_1 = require("lodash");
var AGRefinementList_1 = __importDefault(require("../../molecules/AGRefinementList/AGRefinementList"));
var sortWeekdays_1 = __importDefault(require("../../../functions/sortWeekdays"));
var sortTargetAudience_1 = __importDefault(require("../../../functions/sortTargetAudience"));
var TableHeadBtn = function (_a) {
    var label = _a.label, attribute = _a.attribute, _b = _a.sortAsc, sortAsc = _b === void 0 ? true : _b, width = _a.width;
    return (react_1.default.createElement(TableHeadBtn_styles_1.default, { className: width },
        react_1.default.createElement("button", { className: "button" },
            react_1.default.createElement("span", { className: "text" }, label),
            react_1.default.createElement("svg", { className: "icon icon-filter", "aria-hidden": "true" },
                react_1.default.createElement("use", { xmlnsXlink: 'http://www.w3.org/1999/xlink', xlinkHref: '/dist/svg/sprite.min.svg#filter' }))),
        sortAsc &&
            react_1.default.createElement(AGRefinementList_1.default, { attribute: attribute, transformItems: function (items) { return lodash_1.orderBy(items, "label", "asc"); }, limit: 1000, searchable: true }),
        !sortAsc && (attribute === "day") &&
            react_1.default.createElement(AGRefinementList_1.default, { attribute: attribute, transformItems: function (items) { return sortWeekdays_1.default(items); }, limit: 100, searchable: true }),
        !sortAsc && (attribute === "target_audience") &&
            react_1.default.createElement(AGRefinementList_1.default, { attribute: attribute, transformItems: function (items) { return sortTargetAudience_1.default(items); }, limit: 100, searchable: true })));
};
exports.default = TableHeadBtn;
